import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { Button, Spinner, ItemPreview } from 'components'
import { FlowHeader } from '../../components'
import SubmarkLogo from 'resources/Logo/submark-logo-2.png'

import { 
    clientContext,
    triggerContext
} from 'context'
import * as api from 'api';
import { Item } from 'schema';
import { getTemplate } from 'templates'
const template = getTemplate('getting-started', {userID: 'uid'})

const Container = styled.div`
    background-color: var(--secondary-color);
    border: 1px solid var(--primary-accent-color);
    border-radius: 5px;
    box-shadow: var(--box-shadow);
    padding: 1rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 30rem;
    max-width: 90vw;
    height: 40rem;
`

const Title = styled.div`
    font-weight: bold;
    font-size: 2rem;
    margin: 1rem 0 0 0;
`

const Subtitle = styled.div`
    /* font-size: 0.8rem; */
    /* color: var(--subtitle-color); */
    margin: 1rem 0 0 0;
    text-align: center;
    display: grid;
    grid-template-columns: min-content auto;
    grid-column-gap: 0.5rem;
    justify-content: center;
    align-items: center;
    width: 80%;
`

const iconStyle = {
    width:'2rem', 
    height:'2rem',
    objectFit:'contain', 
    marginRight:'0.1rem'
}

const submitStyle = {
    fontWeight: 'bold',
    backgroundColor: 'var(--focus-color)',
    fontSize: '1rem',
    margin: '0.5rem 0 0 0',
    width: '5rem'
}

const cancelStyle = {
    fontSize: '0.8rem',
    backgroundColor: 'var(--secondary-color)',
    boxShadowColor: 'transparnet',
    textDecoration: 'underline',
    margin: '0.5rem 0 0 0'
}

const iconRef = {
    'not-started': '',
    'in-progress': '',
    'completed': '🎉',
    'failed': '🚧',
    'invalid': '🚧',
    'creating': '🤖'
}

const TriggerScreen = props => {
    const {
        state,
        onSubmit
    } = props;
    const [testing, setTesting] = React.useState('not-started');
    const [itemPreview, setItemPreview] = React.useState(null);
    const user = useSelector(state => state.auth.user);
    const clients = useSelector((state) => state.integration.clients);
    const data = useSelector((state) => state.db.present.data && state.db.present.data.toJS());
    const direction = state.workflow['direction'];

    const testHandler = async () => {
        setTesting('in-progress')
        setTimeout(() => {
            const key = direction === 'INFLOW' ? 'trigger' : 'action'
            clientContext[state.workflow[key]['client']]['test'][direction][state.workflow[key][key]]({...state, userId: user['uid'], data: data})
            .then(res => {
                if(direction === 'INFLOW'){
                    setTesting(res['success'] && res['items'].length > 0 ? 'completed' : 'failed')
                    setItemPreview(<ItemPreview item={res['items'][0]}/>)
                } else if (direction === 'OUTFLOW') {
                    // setTesting(res['success'] ? 'completed' : 'failed')
                    setTesting('failed')
                }
            })
            .catch(err => {
                console.log('[Test trigger] Failed', err)
            }) 
        }, 500)
        
    }

    const onSubmitHandler = (test) => {
        setTesting('creating') 
        onSubmit && setTimeout(() => { onSubmit( (isValid) => !isValid && setTesting('invalid')) }, 1000)        
    }

    const getSubtitle = () => {
        let subtitle;

        if(direction === 'INFLOW'){
            const trigger = state.trigger['client'] && state.trigger['trigger'] ? triggerContext[state.trigger['client']][state.trigger['trigger']]['title'].toLowerCase() : '(trigger_name)'
            const app = clientContext[state.trigger['client']]['title'] || 'app_name'
            const client = Object.values(clients).filter(client => client['clientId'] === state.trigger['clientId'])[0]
            const account = client['clientTitle'] || state.trigger['clientId'] || 'account_name'

            if(testing === 'not-started'){}
            subtitle = testing === 'not-started' ? `Trigger a ${trigger} in your ${app} account (${account}). We'll find a matching item to create in Atomicly`
                    : testing === 'completed' ? `Received trigger from your ${app} account (${account})`
                    : testing === 'failed' ? `Didn't receive a trigger from your ${app} account (${account}). Trigger a ${trigger} again and test it again.`
                    : testing === 'in-progress' ? `Listening for ${trigger}`
                    : testing === 'creating' ? 'Creating workflow'
                    : testing === 'invalid' ? 'Something went wrong'
                    : null
        } 
        else if (direction === 'OUTFLOW' && clients){
            const clientName = state.action['client'] && state.action['client'] ? clientContext[state.action['client']]['title'] : '(client_name)'
            const clientId = state.action['clientId']
            const client = Object.values(clients).filter(client => client['clientId'] === clientId)[0]
            subtitle = `We'll send a dummy item to your ${clientName} account. Press the button below and check your account (${client['clientTitle']}) if you received it.`
        }
        
        return subtitle
    }

    const subtitle = getSubtitle()

    return (
        <Container>
            <FlowHeader 
                triggerIcon={<img src={direction === 'OUTFLOW' ? SubmarkLogo : clientContext[state.trigger.client]['icon']['value']} style={iconStyle}/>}
                actionIcon={<img src={direction === 'INFLOW' ? SubmarkLogo : clientContext[state.action.client]['icon']['value']}  style={iconStyle}/>}
                backgroundColor={{
                    trigger: direction === 'OUTFLOW' && 'var(--focus-color)',
                    action: direction === 'INFLOW' && 'var(--focus-color)'
                }}/>
            <Title>Test your workflow</Title>

            {/* Display */}
            <Subtitle>
                <div style={{fontSize: '2rem'}}>{iconRef[testing]}</div>
                <div>{subtitle}</div>
            </Subtitle>
            {testing === 'completed' && itemPreview}

            {/* Buttons */}
            <Button styles={submitStyle} 
                text={testing === 'not-started' ? 'Test'
                    : ['in-progress', 'creating'].includes(testing) ? <Spinner styles={{color: 'var(--text-color)'}}/>
                    : testing === 'completed' ? 'Save'
                    : 'Test'}
                onSelect={() => {
                    if(['not-started', 'failed', 'invalid'].includes(testing)) { testHandler() }
                    else if (testing === 'completed') { onSubmitHandler(true) }
                }}/>
            <Button text='Continue without testing' styles={cancelStyle} onSelect={() => onSubmitHandler(false) }/>
        </Container>
    )
}

export default TriggerScreen